module.exports = __webpack_public_path__ + "static/title_ie_bg-e37b5a10571cd2bc4404698c35d6c5e5.svg";